import classNames from 'classnames';
import { CSSProperties } from 'react';
import styles from './Skeleton.module.scss';

type TSkeletonVariant = 'text' | 'rectangular' | 'rounded' | 'circular';
type TSkeletonAnimation = 'wave' | 'pulse' | false;

interface ISkeletonProps {
  variant?: TSkeletonVariant;
  width?: number | string;
  height?: number | string;
  animation?: TSkeletonAnimation;
  className?: string;
}

const toCssSize = (value: number | string | undefined): string | undefined =>
  typeof value === 'number' ? `${value}px` : value;

export function Skeleton({ variant = 'text', width, height, animation = 'wave', className }: ISkeletonProps) {
  'use memo';

  return (
    <div
      aria-hidden="true"
      className={classNames(styles.skeleton, styles[variant], animation && styles[animation], className)}
      style={
        {
          '--skeleton-width': toCssSize(width),
          '--skeleton-height': toCssSize(height),
        } as CSSProperties
      }
    />
  );
}
